import React from 'react';
import Intro from '../../assets/img/guide/Intro.PNG';
import { GuideImg } from '../../container/views/guide';
import { MainTitle } from '.';
import routeConstant from '../../constants/route.constants';
import FullPageLink from './FullPageLink';

const IntroModal = () => {
  return (
    <div className="modal-content-wrapper">
      <MainTitle>Chào mừng bạn đến với Emil.vn</MainTitle>
      <FullPageLink url={routeConstant.INTRODUCTION} />

      <div className="main-content">
        <div id="main_0_DivCode">
          <div>
            <p>Thưa các bạn,</p>
            <p>Không biết mình ở đâu trong thế giới này là 1 điều đáng tiếc.</p>
            <span>
              Ở mức độ cơ bản nhất, tất cả chúng ta đều được sinh ra ở 1 thời điểm nào đó, có cha
              mẹ, ông bà, cô chú bác, tổ tiên nhất định
            </span>
            <div style={{ textAlign: 'center' }}>
              <GuideImg src={Intro} />
            </div>

            <p>
              Thời đại mới nhiều mối lo trong cuộc sống, liệu bạn có còn đủ thời gian để nhớ, nghĩ
              về gia đình, họ hàng, nguồn cội của mình? Liệu bạn có còn nhớ được tên, tuổi, các
              thông tin về họ?
            </p>
            <p>
              Việc khó nắm bắt được những mối quan hệ quanh ta chỉ là hệ quả tất yếu của cuộc sống
              hiện đại luôn mở rộng mỗi ngày, và nó dần trở nên khó khăn hơn đối với các thế hệ sau
              khi số lượng họ hàng ngày càng nhiều lên.
            </p>
            <p>
              Do đó, ứng dụng Web <b>Emil.vn</b> đã ra đời với mục đích giúp chúng ta lưu lại để ghi
              nhớ hệ thống gia phả, họ hàng to lớn nhưng vô cùng quan trọng này.
            </p>
            <p>
              Đặc biệt, ứng dụng rất bổ ích cho trẻ em vì có thể vừa học vừa chơi. Người lớn thì có
              thể dễ dàng tra cứu, in ấn.
            </p>

            <b>Một số tính năng nổi bật của hệ thống:</b>
            <ul>
              <li>Biểu đồ hiện đại, dễ dàng chỉnh sửa thông tin và sắp xếp.</li>
              <li>
                Đăng nhập nhanh chóng bằng tài khoảng GMail mà không cần tạo tài khoản mới trên hệ
                thống.
              </li>
              <li>Dữ liệu được lưu trên Điện toán đám mây, đảm bảo an ninh và hiệu năng cao.</li>
              <li>Hỗ trợ ghép ảnh nền, xuất file ảnh để in ấn, chia sẻ biểu đồ với người thân.</li>
              <li>
                Miễn phí với mọi tính năng, chỉ thu thêm phí nếu bạn có nhu cầu lưu trữ ảnh lớn.
              </li>
            </ul>
            <br />
            <p>
              Chúc các bạn có những trải nghiệm vui vẻ với Emil.vn. Hi vọng đây sẽ là 1 công cụ hữu
              ích cho bạn trong cuộc sống.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroModal;
